import React from 'react';

import { useHasRole } from '../hooks';

export default function RequireRole(props) {
    const { role, children } = props;
    const hasRequiredRole = useHasRole(role);

    return hasRequiredRole ? <>{children}</> : null;
}